import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { SidePanel, SidePanelContent, SidePanelFooter } from '@securspace/securspace-ui-kit';
import type { Booking } from '../../../../../types/Booking';

interface CancelBookingPanelProps {
  open: boolean;
  onClose: () => void;
  cancelBooking: () => void;
  booking: Booking;
}

const CancelBookingPanel = (props: CancelBookingPanelProps) => {
  const { open, onClose, cancelBooking, booking } = props;

  return (
    <SidePanel open={open} onClose={onClose} title={`Cancel Booking ${booking?.orderNumber ?? ''}`}>
      <SidePanelContent>
        <Grid container>
          <Grid item>
            <Typography>Are you sure you want to cancel this booking request?</Typography>
          </Grid>
        </Grid>
      </SidePanelContent>
      <SidePanelFooter>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={onClose}
              sx={{ py: 1.5, textTransform: 'none', fontSize: '1rem' }}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={8}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={cancelBooking}
              sx={{ py: 1.5, textTransform: 'none', fontSize: '1rem' }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </SidePanelFooter>
    </SidePanel>
  );
};

export default CancelBookingPanel;

